module.exports = __webpack_public_path__ + "media/item01.03d77fc4.webm";